import { render } from "./EditInscriptionPage.vue?vue&type=template&id=9d495fa4&ts=true"
import script from "./EditInscriptionPage.vue?vue&type=script&lang=ts"
export * from "./EditInscriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__